import { Theme } from '@mui/material/styles'

export default function variables(theme: Theme): string {
    return `
:root {
    --ds-spacing-1: ${theme.spacing(1)};
    --ds-spacing-2: ${theme.spacing(2)};
    --ds-spacing-3: ${theme.spacing(3)};
    --ds-spacing-4: ${theme.spacing(4)};
    --ds-spacing-5: ${theme.spacing(5)};
    --ds-spacing-6: ${theme.spacing(6)};
    --ds-spacing-7: ${theme.spacing(7)};
    --ds-spacing-8: ${theme.spacing(8)};
    --ds-spacing-9: ${theme.spacing(9)};
    --ds-spacing-10: ${theme.spacing(10)};

    --ds-breakpoint-xs: ${theme.breakpoints.values.xs}px;
    --ds-breakpoint-sm: ${theme.breakpoints.values.sm}px;
    --ds-breakpoint-md: ${theme.breakpoints.values.md}px;
    --ds-breakpoint-lg: ${theme.breakpoints.values.lg}px;
    --ds-breakpoint-xl: ${theme.breakpoints.values.xl}px;
}
`
}
